import { createContext, useContext, useEffect, useState, useCallback } from "react";

const LayoutsContext = createContext();

function LayoutsProvider({ children }) {
	const [layouts, setLayouts] = useState([]);
	const [loading, setLoading] = useState(true);

	const fetchLayouts = useCallback(async () => {
		setLoading(true);
		try {
			const res = await fetch(responsive_addons_site_builder.rest_url + 'site-builder-layouts', {
				method: "GET",
				headers: {
					"X-WP-Nonce": responsive_addons_site_builder.nonce,
					"Content-Type": "application/json",
				},
			});

			if (!res.ok) {
				throw new Error(`HTTP error! status: ${res.status} => ${res.statusText}`);
			}

			const data = await res.json();
			setLayouts(data);
		} catch (error) {
			console.error("Fetch error:", error);
		} finally {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		fetchLayouts();
	}, [fetchLayouts]);

	return (
		<LayoutsContext.Provider value={{ loading, layouts, refreshLayouts: fetchLayouts }}>
			{children}
		</LayoutsContext.Provider>
	);
}

function useLayouts() {
	const context = useContext(LayoutsContext);
	if (!context) {
		throw new Error("useLayouts must be used within a LayoutsProvider");
	}
	return context;
}

export { LayoutsProvider, useLayouts };
